<template>
  <v-container>
    <div v-if="templateById">
      <v-layout row>
        <v-flex xs12 mb-6>
          <div v-if="!started">
            <h1>
              <span class="font-weight-light">{{$t('newEvaluationHeader')}}</span>
              {{templateById.title}}
            </h1>
          </div>
          <div v-else>
            <h1>{{templateById.title}}</h1>
          </div>
        </v-flex>
      </v-layout>
      <div v-if="allTeams && !started">
        <v-layout row pt-3>
          <v-flex xs 12>
            <v-select
              :items="allTeams.nodes"
              item-text="name"
              item-value="id"
              :label="$t('team')"
              class="title"
              v-model="selectedTeam"
              return-object
            ></v-select>
        
          </v-flex>
        </v-layout>

        <v-layout v-if="allParticipants && selectedTeam && !started" pt-3>
          <v-flex xs4>
            <v-card>
              <v-card-title>
                {{$t('participants')}}
                <v-spacer/>
                <v-text-field
                  clearable
                  :label="$t('search')"
                  single-line
                  hide-details
                  v-model="search"
                  @keyup.escape="search = ''"
                ></v-text-field>
              </v-card-title>
              <v-data-table class="allparticipants"
                v-model="selected"
                :items="allParticipants.nodes"
                :headers="participantsHeaders"
                :search="search"
                hide-headers
                hide-actions
                  @keyup.escape="search = ''"
                >
                <template slot="items" slot-scope="props">
                  <tr :active="props.selected" @click="selectParticipant(props)">
                    <!--<td class="text-xs-right">{{props.item.firstName}}</td>-->
                    <td>{{props.item.fullName}}</td>
                  </tr>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
          <v-flex xs2 offset-xs1>
            <v-card>
              <v-card-title>
                {{$t('roles')}}
              </v-card-title>
              <v-list>
                <v-list-tile
                  v-for="item in roles"
                  :key="item.id"
                  :class="item.assigned ? 'assigned' : ''"
                  v-model="item.selected"
                  @click="selectRole(item)"
                  >
                  <v-list-tile-content>
                    <v-list-tile-title v-text="item.title"></v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-card>
          </v-flex>
          <v-flex xs4 offset-xs1>
            <v-card>
              <v-card-title>
                {{$t('selectedParticipants')}}
              </v-card-title>
              <v-list>
                <v-list-tile
                  v-for="(item,index) in participations"
                  :key="item.id"
                  v-model="item.selected"
                  @click="selectParticipation(item)"
                  >
                  <v-list-tile-content v-if="item.participant">
                    <v-list-tile-title v-text="item.participant.fullName"></v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-content v-else>
                    <v-list-tile-title class="grey--text">{{$t('participant')}} {{index+1}}</v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-action v-if="item.role">
                    {{item.role.title}}
                  </v-list-tile-action>
                </v-list-tile>
              </v-list>
            </v-card>
          </v-flex>
        </v-layout>

        <v-layout row py-3>
          <v-flex xs12>
            <v-btn
              block
              color="primary"
              :disabled="started || !startable"
              :dark="!started && startable"
              @click="startNewEvaluation"
            >{{$t('startEvaluation')}}</v-btn>
          </v-flex>
        </v-layout>

      </div>
    </div>
  </v-container>
</template>

<style scoped>
.allparticipants {
   height: 350px; 
   overflow-y: auto;
}
.v-list .assigned {
  color: #888;
}
.v-datatable td {
  font-size: 16px;
}
.allparticipants td {
  cursor: pointer;
}
.allparticipants tr[active=true] td {
  color: #009688;
  background-color: #f5f5f5;
}
</style>

<script>
import { templateByIdQuery } from "@/graphql/templateQueries.gql";
import {
  newEvalMutation,
  newParticipationMutation,
  categoriesQuery,
  allEvaluationsBasicQuery
} from "@/graphql/evaluationQueries.gql";
import {
  allParticipantsQuery,
  allParticipantRolesQuery,
  allTeamsQuery
} from "@/graphql/participantQueries.gql";


export default {
  apollo: {
    templateById: {
      query: templateByIdQuery,
      variables() {
        return {
          templateId: this.templateId
        };
      }
    },
    allParticipants: allParticipantsQuery,
    allParticipantRoles: allParticipantRolesQuery,
    allCategories: categoriesQuery,
    allTeams: allTeamsQuery
  },
  methods: {
    selectParticipant(props) {
      if (!props.selected) {
        props.selected = true
        const participation = {
          participant: props.item,
          role: null
        }
        const index = this.participations.findIndex(p => !p.participant)
        if (index >= 0) {
          this.participations.splice(index, 1, participation)
        } else {
          this.participations.push(participation)
        }
        // Select newly added participant if previous have role selected, allowing participant-role selection
        if (this.participations.filter(p => p.participant && !p.role).length <= 1) {
          this.selectParticipation(participation)
        }
      } else {
        props.selected = false
        const index = this.participations.findIndex(p => p.participant && p.participant.id === props.item.id)
        if (index >= 0) {
          this.participations.splice(index, 1, {})
        }
      }
      if (this.participations.length > this.roles.length) {
        if (this.selected.length > this.roles.length) {
          const index = this.selected.findIndex(s => s.id === this.participations[0].participant.id)
          if (index >= 0) this.selected.splice(index,1)
        }
        this.participations.splice(0,1)
        this.updateRolesAssigned()
      }
    },
    clearSelection() {
      this.selectedParticipation = null
      this.selectedRole = null
      for (var p of this.participations) p.selected = false
      for (var r of this.roles) r.selected = false
      this.updateRolesAssigned()
    },
    updateRolesAssigned() {
      for (var r of this.roles) {
        r.assigned = this.participations.find(p => p.role && p.role.id === r.id) ? true : false
      }
    },
    selectParticipation(participation) {
      if (this.selectedRole) {
        for (const p of this.participations) {
          if (p.role == this.selectedRole) p.role = null
        }
        participation.role = this.selectedRole
        this.clearSelection()
      } else {
        this.clearSelection()
        participation.selected = true
        this.selectedParticipation = participation
      }
      this.$forceUpdate()
    },
    selectNextParticipationMissingRole() {
      this.clearSelection()
      for (const participation of this.participations) {
        if (!participation.role) {
          participation.selected = true
          this.selectedParticipation = participation
          break
        }
      }
    },
    selectRole(role) {
      if (this.selectedParticipation) {
        for (const participation of this.participations) {
          if (participation.role == role) participation.role = null
        }
        this.selectedParticipation.role = role
        this.selectNextParticipationMissingRole()
      } else {
        this.clearSelection()
        role.selected = true
        this.selectedRole = role
      }
      this.$forceUpdate()
    },
    addNewEvaluation() {
      this.$apollo
        .mutate({
          mutation: newEvalMutation,
          variables: {
            EvaluationData: {
              evaluation: {
                id: this.evaluationId,
                templateId: this.templateId,
                teamId: this.selectedTeam ? this.selectedTeam.id : null,
                evaluatorUserId: this.currentUser.id,
                startTime: this.moment().format(),
                endTime: null,
                deleted: false
              }
            }
          },
          refetchQueries: [ 
            { query: allEvaluationsBasicQuery },
          ],
        })
        .then(() => {
          this.addParticipations();
        });
    },
    addParticipations() {
      for (var participantIndex in this.participations) {
        this.$apollo
          .mutate({
            mutation: newParticipationMutation,
            variables: {
              ParticipationData: {
                participation: {
                  evaluationId: this.evaluationId,
                  participantId: this.participations[participantIndex]
                    .participant.id,
                  roleId: this.participations[participantIndex].role.id
                }
              }
            }
          })
          .then(() => {
            this.goToEvaluation()
          });
      }
    },

    startNewEvaluation() {
      if (this.startable) {
        this.addNewEvaluation();
      }
    },
    goToEvaluation () {
      if(this.evaluationId){
        this.$router.push({ name: 'evaluation', params: {evaluationId: this.evaluationId}}) //params: ... 
      }
    },
    guid() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(
        c
      ) {
        var r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },
    keyHandler(e) {
      if (e.keyCode == 27) this.search = ''
    },
  },
  mounted() {
    if (!this.templateId) {
      this.$router.push({ name: "home" });
    }
    this.evaluationId = this.guid();
    document.body.addEventListener('keyup', this.keyHandler)
  },
  destroyed() {
    document.body.removeEventListener('keyup', this.keyHandler)
  },
  computed: {
    currentUser() { return this.$store.state.currentUser },
    roles() { return this.templateById && this.templateById.rolesList },
    startable() {
      if (!this.selectedTeam) return false;
      if (this.participations.length == 0) return false;
      for (const participation of this.participations) {
        if (!participation.participant || !participation.role) return false;
      }
      return true;
    },
  },
  data() {
    return {
      started: false,
      templateById: null,
      allParticipants: null,
      allParticipantRoles: null,
      selectedTeam:null,
      participations: [{},{},{},{}],
      participantsHeaders: [
        {
          text: 'First name',
          value: 'firstName',
          align: 'right',
          width: '1%'
        },
        {
          text: 'Last name',
          value: 'lastName',
        }
      ],
      search: '',
      selected: [],
      selectedParticipation: null,
      selectedRole: null,
    };
  },
  props: ["templateId"]
};
</script>
